import MomentUtils from "@date-io/moment";
import {
	KeyboardDatePicker,
	MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import type { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { useSearchParams } from "react-router-dom";
import { useFormsContext } from "../context/formsContext";
import { useEffect } from "react";

type Props = {};

export const StartFilter = ({}: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const {
		state: {
			dataToGetFormInstances: { Start, End },
		},
		actions,
	} = useFormsContext();

	const handleDateChange = (datePicker: MaterialUiPickersDate) => {
		if (datePicker && datePicker.isAfter(End)) {
			return;
		}

		searchParams.set(
			"start",
			encodeURIComponent(datePicker!.toDate().toISOString()),
		);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<MuiPickersUtilsProvider utils={MomentUtils}>
			<KeyboardDatePicker
				disableToolbar
				variant="inline"
				format="MM/DD/YYYY"
				id="date-picker-inline"
				style={{
					minWidth: "100%",
					borderTopLeftRadius: 3,
					borderTopRightRadius: 3,
				}}
				label="Start"
				value={Start}
				onChange={handleDateChange}
				KeyboardButtonProps={{
					"aria-label": "change date",
				}}
				maxDate={End}
			/>
		</MuiPickersUtilsProvider>
	);
};
